import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from '../messages';

// noinspection JSValidateTypes
const ShipFromLabel = () => <FormattedMessage {...messages.shipFrom} />;
export default ShipFromLabel;
